import React, { useState, useEffect, useMemo } from 'react';
import { collection, getDocs, doc, updateDoc, query, where } from 'firebase/firestore';
import { db } from '../../config/firebaseConfig';
import { toast } from 'react-toastify';
import { PROJECT_DESIGN_OPTIONS } from '../../utils/projectDesign';
import styles from './EditProjectModal.module.css';
import { FaEdit, FaTimes, FaUser } from 'react-icons/fa';
import Select from 'react-select';

const departments = [
  { value: 'Acil Tıp', label: 'Acil Tıp' },
  { value: 'Adli Tıp', label: 'Adli Tıp' },
  { value: 'Aile Hekimliği', label: 'Aile Hekimliği' },
  {
    value: 'Anesteziyoloji ve Reanimasyon',
    label: 'Anesteziyoloji ve Reanimasyon',
  },
  { value: 'Beyin ve Sinir Cerrahisi', label: 'Beyin ve Sinir Cerrahisi' },
  { value: 'Biyokimya', label: 'Biyokimya' },
  { value: 'Çocuk Cerrahisi', label: 'Çocuk Cerrahisi' },
  {
    value: 'Çocuk Sağlığı ve Hastalıkları',
    label: 'Çocuk Sağlığı ve Hastalıkları',
  },
  { value: 'Dahiliye', label: 'Dahiliye' },
  { value: 'Dermatoloji', label: 'Dermatoloji' },
  { value: 'Enfeksiyon Hastalıkları', label: 'Enfeksiyon Hastalıkları' },
  {
    value: 'Fiziksel Tıp ve Rehabilitasyon',
    label: 'Fiziksel Tıp ve Rehabilitasyon',
  },
  { value: 'Gastroenteroloji', label: 'Gastroenteroloji' },
  { value: 'Göğüs Cerrahisi', label: 'Göğüs Cerrahisi' },
  { value: 'Göğüs Hastalıkları', label: 'Göğüs Hastalıkları' },
  { value: 'Göz Hastalıkları', label: 'Göz Hastalıkları' },
  { value: 'Hematoloji', label: 'Hematoloji' },
  { value: 'Histoloji ve Embriyoloji', label: 'Histoloji ve Embriyoloji' },
  { value: 'İç Hastalıkları', label: 'İç Hastalıkları' },
  {
    value: 'Kadın Hastalıkları ve Doğum',
    label: 'Kadın Hastalıkları ve Doğum',
  },
  { value: 'Kalp ve Damar Cerrahisi', label: 'Kalp ve Damar Cerrahisi' },
  { value: 'Kardiyoloji', label: 'Kardiyoloji' },
  {
    value: 'Kulak Burun Boğaz (KBB) Hastalıkları',
    label: 'Kulak Burun Boğaz (KBB) Hastalıkları',
  },
  { value: 'Nefroloji', label: 'Nefroloji' },
  { value: 'Nöroloji', label: 'Nöroloji' },
  { value: 'Ortopedi ve Travmatoloji', label: 'Ortopedi ve Travmatoloji' },
  { value: 'Patoloji', label: 'Patoloji' },
  {
    value: 'Plastik, Rekonstrüktif ve Estetik Cerrahi',
    label: 'Plastik, Rekonstrüktif ve Estetik Cerrahi',
  },
  { value: 'Psikiyatri', label: 'Psikiyatri' },
  { value: 'Radyasyon Onkolojisi', label: 'Radyasyon Onkolojisi' },
  { value: 'Radyoloji', label: 'Radyoloji' },
  { value: 'Spor Hekimliği', label: 'Spor Hekimliği' },
  { value: 'Tıbbi Biyoloji', label: 'Tıbbi Biyoloji' },
  { value: 'Tıbbi Farmakoloji', label: 'Tıbbi Farmakoloji' },
  { value: 'Tıbbi Genetik', label: 'Tıbbi Genetik' },
  { value: 'Tıbbi Mikrobiyoloji', label: 'Tıbbi Mikrobiyoloji' },
  { value: 'Tıbbi Onkoloji', label: 'Tıbbi Onkoloji' },
  { value: 'Tıbbi Patoloji', label: 'Tıbbi Patoloji' },
  { value: 'Üroloji', label: 'Üroloji' },
];

const centerTypes = [
  { value: 'Ev', label: 'Ev' },
  { value: 'Hastane', label: 'Hastane' },
  { value: 'Eş Zamanlı', label: 'Eş Zamanlı' },
];

const phases = [
  { value: 'Faz I', label: 'Faz I' },
  { value: 'Faz II', label: 'Faz II' },
  { value: 'Faz III', label: 'Faz III' },
  { value: 'Düşük Riskli Bilimsel Çalışma', label: 'Düşük Riskli Bilimsel Çalışma' },
  { value: 'Beşeri Tıbbi Ürünlerin Adaptif Tasarımlı Klinik Araştırması (Faz I/II)', label: 'Beşeri Tıbbi Ürünlerin Adaptif Tasarımlı Klinik Araştırması (Faz I/II)' },
  { value: 'Beşeri Tıbbi Ürünlerin Adaptif Tasarımlı Klinik Araştırması (Faz I/III)', label: 'Beşeri Tıbbi Ürünlerin Adaptif Tasarımlı Klinik Araştırması (Faz I/III)' },
  { value: 'Beşeri Tıbbi Ürünlerin Adaptif Tasarımlı Klinik Araştırması (Faz II/III)', label: 'Beşeri Tıbbi Ürünlerin Adaptif Tasarımlı Klinik Araştırması (Faz II/III)' },
  { value: 'Sağlık Beyanlı Ürün/Yöntem Çalışması', label: 'Sağlık Beyanlı Ürün/Yöntem Çalışması' },
  { value: 'Beşeri Tıbbi Ürünlerin Gözlemsel Çalışması', label: 'Beşeri Tıbbi Ürünlerin Gözlemsel Çalışması' },
  { value: 'Kök hücreler ile yapılan klinik araştırması', label: 'Kök hücreler ile yapılan klinik araştırması' },
];

const EditProjectModal = ({ project, onClose, onUpdate }) => {
  const [formData, setFormData] = useState({
    customer: '',
    coordinatorAcademician: '',
    ethicsCommitteeDate: '',
    ethicsCommitteeNumber: '',
    ethicsCommitteePlace: '',
    firstInvoiceDate: '',
    paymentFrequency: '',
    projectCentersType: '',
    projectDate: '',
    projectDepartment: '',
    projectDueDate: '',
    projectPhase: '',
    projectDesign: '',
    protocolNumber: '',
    sbFirstApprovalDate: '',
    sbFirstApprovalNumber: '',
    sbProjectNumber: '',
    titleLong: '',
    titleShort: '',
    center: '',
    isCurrencyFixed: false,
    fixedCurrencyRate: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [centers, setCenters] = useState([]);
  const [externalPersonnels, setExternalPersonnels] = useState([]);

  // Initialize form data with project values
  useEffect(() => {
    if (project) {
      setFormData({
        customer: project.customer || '',
        coordinatorAcademician: project.coordinatorAcademician || '',
        ethicsCommitteeDate: project.ethicsCommitteeDate || '',
        ethicsCommitteeNumber: project.ethicsCommitteeNumber || '',
        ethicsCommitteePlace: project.ethicsCommitteePlace || '',
        firstInvoiceDate: project.firstInvoiceDate || '',
        paymentFrequency: project.paymentFrequency || '',
        projectCentersType: project.projectCentersType || '',
        projectDate: project.projectDate || '',
        projectDepartment: project.projectDepartment || '',
        projectDueDate: project.projectDueDate || '',
        projectPhase: project.projectPhase || '',
        projectDesign: project.projectDesign || '',
        protocolNumber: project.protocolNumber || '',
        sbFirstApprovalDate: project.sbFirstApprovalDate || '',
        sbFirstApprovalNumber: project.sbFirstApprovalNumber || '',
        sbProjectNumber: project.sbProjectNumber || '',
        titleLong: project.titleLong || '',
        titleShort: project.titleShort || '',
        center: project.center || '',
        isCurrencyFixed: !!project.isCurrencyFixed,
        fixedCurrencyRate: project.fixedCurrencyRate || '',
      });
    }
  }, [project]);

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'Customers'));
        const customersData = querySnapshot.docs
          .map((doc) => ({
            value: doc.data().Başlık,
            label: doc.data().Başlık,
          }))
          .filter((item) => item.label)
          .sort((a, b) => a.label.localeCompare(b.label));
        setCustomers(customersData);
      } catch (error) {
        console.error('Error fetching customers:', error);
        toast.error('Müşteriler yüklenirken bir hata oluştu!');
      }
    };

    fetchCustomers();
  }, []);

  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'Centers'));
        const centersData = querySnapshot.docs
          .map((doc) => ({
            value: doc.data().Adı,
            label: doc.data().Adı,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setCenters(centersData);
      } catch (error) {
        console.error('Error fetching centers:', error);
        toast.error('Merkezler yüklenirken bir hata oluştu!');
      }
    };

    fetchCenters();
  }, []);

  // AddProjectModal ile aynı kaynak: koordinatör akademisyen seçenekleri
  // ExternalPersonnels koleksiyonundan gelir
  useEffect(() => {
    const fetchExternalPersonnels = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'ExternalPersonnels'));
        const personnelsData = querySnapshot.docs
          .map((docSnap) => {
            const data = docSnap.data();
            const fullName = `${data['Adı'] || ''} ${data['Soyadı'] || ''}`.trim();
            return {
              value: fullName,
              label: fullName,
            };
          })
          .filter((item) => item.label)
          .sort((a, b) => a.label.localeCompare(b.label, 'tr'));
        setExternalPersonnels(personnelsData);
      } catch (error) {
        console.error('Error fetching external personnels:', error);
        toast.error('Harici personeller yüklenirken bir hata oluştu!');
      }
    };

    fetchExternalPersonnels();
  }, []);

  // Mevcut projede listede olmayan (eski serbest metin) bir akademisyen varsa
  // seçenek olarak korunur; kayıt silinmeden görüntülenip değiştirilebilir
  const coordinatorOptions = useMemo(() => {
    const current = formData.coordinatorAcademician;
    if (current && !externalPersonnels.some((p) => p.value === current)) {
      return [{ value: current, label: `${current} (liste dışı)` }, ...externalPersonnels];
    }
    return externalPersonnels;
  }, [externalPersonnels, formData.coordinatorAcademician]);

  const handleChange = (e) => {
    if (e?.target) {
      const { name, value } = e.target;
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  // AddProjectModal ile aynı davranış: müşteri seçilince Ödeme Periyodu alanı
  // müşteri kartından otomatik doldurulur
  const handleSelectChange = async (selectedOption) => {
    try {
      const customersRef = collection(db, 'Customers');
      const q = query(customersRef, where('Başlık', '==', selectedOption.value));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const customerData = querySnapshot.docs[0].data();
        const odemePeriyodu = customerData['Ödeme Periyodu'];

        setFormData((prevState) => ({
          ...prevState,
          customer: selectedOption.value,
          paymentFrequency: odemePeriyodu || prevState.paymentFrequency,
        }));
      } else {
        setFormData((prevState) => ({
          ...prevState,
          customer: selectedOption.value,
        }));
      }
    } catch (error) {
      console.error('Error fetching customer data:', error);
      toast.error('Müşteri bilgileri alınırken bir hata oluştu!');
      setFormData((prevState) => ({
        ...prevState,
        customer: selectedOption.value,
      }));
    }
  };

  const handleCoordinatorChange = (selectedOption) => {
    setFormData((prevState) => ({
      ...prevState,
      coordinatorAcademician: selectedOption ? selectedOption.value : '',
    }));
  };

  const handleDepartmentChange = (selectedOption) => {
    setFormData((prevState) => ({
      ...prevState,
      projectDepartment: selectedOption.value,
    }));
  };

  const handleCenterTypeChange = (selectedOption) => {
    setFormData((prevState) => ({
      ...prevState,
      projectCentersType: selectedOption.value,
    }));
  };

  const handlePhaseChange = (selectedOption) => {
    setFormData((prevState) => ({
      ...prevState,
      projectPhase: selectedOption.value,
    }));
  };

  const handleCenterChange = (selectedOption) => {
    setFormData((prevState) => ({
      ...prevState,
      center: selectedOption.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // AddProjectModal ile aynı doğrulamalar
    if (!formData.titleShort || !formData.customer) {
      toast.error('Lütfen gerekli alanları doldurunuz!');
      return;
    }
    if (formData.isCurrencyFixed) {
      const rateNum = parseFloat(formData.fixedCurrencyRate);
      if (!rateNum || rateNum <= 0) {
        toast.error('Sabit kur seçildi. Lütfen geçerli bir kur değeri giriniz.');
        return;
      }
    }

    setIsSubmitting(true);
    try {
      const projectRef = doc(db, 'Projects', project.id);
      await updateDoc(projectRef, formData);
      toast.success('Proje başarıyla güncellendi!');
      onUpdate();
      onClose();
    } catch (error) {
      console.error('Error updating project:', error);
      toast.error('Proje güncellenirken bir hata oluştu!');
    } finally {
      setIsSubmitting(false);
    }
  };

  // AddProjectModal ile aynı react-select tema stilleri (koyu mod desteği)
  const customSelectStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: 'var(--input-bg)',
      borderColor: 'var(--input-border)',
      minHeight: '42px',
      borderRadius: '6px',
      boxShadow: 'none',
      '&:hover': {
        borderColor: 'var(--input-focus-border)',
      },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: 'var(--modal-bg)',
      zIndex: 9999,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused
        ? 'var(--input-focus-border)'
        : 'var(--modal-bg)',
      color: state.isFocused ? 'white' : 'var(--modal-text)',
      '&:hover': {
        backgroundColor: 'var(--input-focus-border)',
        color: 'white',
      },
    }),
    singleValue: (base) => ({
      ...base,
      color: 'var(--modal-text)',
    }),
    input: (base) => ({
      ...base,
      color: 'var(--modal-text)',
    }),
    placeholder: (base) => ({
      ...base,
      color: 'var(--input-placeholder)',
    }),
  };

  const ToggleSwitch = ({
    checked,
    onChange,
    labels = { on: 'Evet', off: 'Hayır' },
  }) => {
    const trackStyle = {
      width: '56px',
      height: '28px',
      borderRadius: '999px',
      background: checked ? 'var(--input-focus-border)' : 'var(--input-border)',
      position: 'relative',
      cursor: 'pointer',
      transition: 'background 0.2s ease',
      display: 'inline-flex',
      alignItems: 'center',
      padding: '0 6px',
    };
    const thumbStyle = {
      width: '22px',
      height: '22px',
      borderRadius: '50%',
      background: 'var(--modal-bg)',
      position: 'absolute',
      top: '3px',
      left: checked ? '31px' : '3px',
      transition: 'left 0.2s ease',
    };
    const labelStyle = {
      marginLeft: '10px',
      color: 'var(--modal-text)',
    };
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div
          role="switch"
          aria-checked={checked}
          onClick={() => onChange(!checked)}
          style={trackStyle}
        >
          <div style={thumbStyle} />
        </div>
        <span style={labelStyle}>{checked ? labels.on : labels.off}</span>
      </div>
    );
  };

  return (
    <div className={styles.modalBackdrop}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>
            <FaEdit className={styles.modalIcon} />
            Proje Düzenle
          </h2>
          <button
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Kapat"
          >
            <FaTimes />
          </button>
        </div>
        <div className={styles.modalContent}>
          <div className={styles.formGroup}>
            <div className={styles.formControl}>
              <label className={styles.label}>Müşteri</label>
              <Select
                options={customers}
                value={
                  customers.find(
                    (option) => option.value === formData.customer
                  ) || ''
                }
                onChange={(selectedOption) =>
                  handleSelectChange(selectedOption)
                }
                placeholder="Müşteri seçin..."
                styles={customSelectStyles}
                classNamePrefix="select"
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>Proje Merkezi</label>
              <Select
                options={centers}
                value={
                  centers.find((option) => option.value === formData.center) ||
                  ''
                }
                onChange={(selectedOption) =>
                  handleCenterChange(selectedOption)
                }
                placeholder="Merkez seçin..."
                styles={customSelectStyles}
                classNamePrefix="select"
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>Proje Merkez Tipi</label>
              <Select
                options={centerTypes}
                value={
                  centerTypes.find(
                    (option) => option.value === formData.projectCentersType
                  ) || ''
                }
                onChange={(selectedOption) =>
                  handleCenterTypeChange(selectedOption)
                }
                placeholder="Merkez tipi seçin..."
                styles={customSelectStyles}
                classNamePrefix="select"
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>Protokol Numarası</label>
              <input
                type="text"
                name="protocolNumber"
                className={styles.input}
                value={formData.protocolNumber}
                onChange={handleChange}
                placeholder="Protokol numarası girin..."
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>Departman</label>
              <Select
                options={departments}
                value={
                  departments.find(
                    (option) => option.value === formData.projectDepartment
                  ) || ''
                }
                onChange={(selectedOption) =>
                  handleDepartmentChange(selectedOption)
                }
                placeholder="Departman seçin..."
                styles={customSelectStyles}
                classNamePrefix="select"
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>
                <FaUser style={{ marginRight: '8px' }} />
                Koordinatör Akademisyen
              </label>
              <Select
                options={coordinatorOptions}
                value={
                  coordinatorOptions.find(
                    (p) => p.value === formData.coordinatorAcademician
                  ) || null
                }
                onChange={handleCoordinatorChange}
                isSearchable={true}
                isClearable={true}
                placeholder="Koordinatör akademisyen seçiniz..."
                styles={customSelectStyles}
                classNamePrefix="select"
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>Proje Design</label>
              <Select
                options={PROJECT_DESIGN_OPTIONS}
                value={PROJECT_DESIGN_OPTIONS.find((option) => option.value === formData.projectDesign) || null}
                onChange={(selectedOption) =>
                  setFormData((prevState) => ({ ...prevState, projectDesign: selectedOption?.value || '' }))
                }
                isClearable
                placeholder="Çift kör, open label veya hibrit..."
                styles={customSelectStyles}
                classNamePrefix="select"
              />
              {formData.projectDesign === 'hybrid' && (
                <small style={{ display: 'block', marginTop: '6px', opacity: 0.8 }}>
                  Hibrit projede primer ve blinded çalışanın açtığı vizit, projeye bağlı unblinded
                  çalışanın takvimine de otomatik düşer. Değişiklik yalnızca yeni vizitleri etkiler.
                </small>
              )}
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>Proje Fazı</label>
              <Select
                options={phases}
                value={
                  phases.find(
                    (option) => option.value === formData.projectPhase
                  ) || ''
                }
                onChange={(selectedOption) => handlePhaseChange(selectedOption)}
                placeholder="Faz seçin..."
                styles={customSelectStyles}
                classNamePrefix="select"
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>Proje Tarihi</label>
              <input
                type="date"
                name="projectDate"
                className={styles.input}
                value={formData.projectDate}
                onChange={handleChange}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>Proje Bitiş Tarihi</label>
              <input
                type="date"
                name="projectDueDate"
                className={styles.input}
                value={formData.projectDueDate}
                onChange={handleChange}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>Ödeme Sıklığı</label>
              <input
                type="text"
                name="paymentFrequency"
                className={styles.input}
                value={formData.paymentFrequency}
                onChange={handleChange}
                placeholder="Ödeme sıklığı girin..."
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>
                Kur Sabitlemesi Yapıldı mı?
              </label>
              <ToggleSwitch
                checked={!!formData.isCurrencyFixed}
                onChange={(val) =>
                  setFormData((prev) => ({ ...prev, isCurrencyFixed: val }))
                }
              />
            </div>

            {formData.isCurrencyFixed && (
              <div className={styles.formControl}>
                <label className={styles.label}>
                  Sabit Kur Değeri (Kaçtan?)
                </label>
                <input
                  type="number"
                  step="0.0001"
                  min="0"
                  name="fixedCurrencyRate"
                  className={styles.input}
                  value={formData.fixedCurrencyRate}
                  onChange={handleChange}
                  placeholder="Örn: 32.1500"
                />
              </div>
            )}

            <div className={styles.formControl}>
              <label className={styles.label}>İlk Fatura Tarihi</label>
              <input
                type="date"
                name="firstInvoiceDate"
                className={styles.input}
                value={formData.firstInvoiceDate}
                onChange={handleChange}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>SB İlk Onay Numarası</label>
              <input
                type="text"
                name="sbFirstApprovalNumber"
                className={styles.input}
                value={formData.sbFirstApprovalNumber}
                onChange={handleChange}
                placeholder="SB ilk onay numarası girin..."
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>SB İlk Onay Tarihi</label>
              <input
                type="date"
                name="sbFirstApprovalDate"
                className={styles.input}
                value={formData.sbFirstApprovalDate}
                onChange={handleChange}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>SB Proje Numarası</label>
              <input
                type="text"
                name="sbProjectNumber"
                className={styles.input}
                value={formData.sbProjectNumber}
                onChange={handleChange}
                placeholder="SB proje numarası girin..."
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>Etik Kurul Tarihi</label>
              <input
                type="date"
                name="ethicsCommitteeDate"
                className={styles.input}
                value={formData.ethicsCommitteeDate}
                onChange={handleChange}
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>Etik Kurul Numarası</label>
              <input
                type="text"
                name="ethicsCommitteeNumber"
                className={styles.input}
                value={formData.ethicsCommitteeNumber}
                onChange={handleChange}
                placeholder="Etik kurul numarası girin..."
              />
            </div>

            <div className={styles.formControl}>
              <label className={styles.label}>Etik Kurul Yeri</label>
              <input
                type="text"
                name="ethicsCommitteePlace"
                className={styles.input}
                value={formData.ethicsCommitteePlace}
                onChange={handleChange}
                placeholder="Etik kurul yerini girin..."
              />
            </div>

            <div className={`${styles.formControl} ${styles.fullWidth}`}>
              <label className={styles.label}>Kısa Başlık</label>
              <input
                type="text"
                name="titleShort"
                className={styles.input}
                value={formData.titleShort}
                onChange={handleChange}
                placeholder="Kısa başlık girin..."
              />
            </div>

            <div className={`${styles.formControl} ${styles.fullWidth}`}>
              <label className={styles.label}>Uzun Başlık</label>
              <textarea
                name="titleLong"
                className={styles.textarea}
                value={formData.titleLong}
                onChange={handleChange}
                placeholder="Uzun başlık girin..."
              />
            </div>
          </div>
        </div>
        <div className={styles.modalFooter}>
          <button className={styles.cancelButton} onClick={onClose}>
            İptal
          </button>
          <button
            className={styles.saveButton}
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className={styles.loadingSpinner}></span>
                Kaydediliyor...
              </>
            ) : (
              'Kaydet'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditProjectModal;
